// Module
var code = "<div if=\"title\" html=\"{{ title }}\" class=\"gc-title\"> </div>";
// Exports
export default code;